import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { SeriesCard } from "../components/SeriesCard";

export default function Watch() {
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/series").then((r) => setSeries(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen grain pb-24 md:pb-12">
      <Navbar />
      <div className="max-w-[1600px] mx-auto px-4 sm:px-8 pt-28">
        <p className="text-xs tracking-[0.3em] uppercase font-bold text-blood mb-2">Browse & Watch</p>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter text-white mb-8">All Series</h1>
        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="animate-spin text-blood" size={36} /></div>
        ) : series.length === 0 ? (
          <p className="text-white/50 py-16">No series available yet.</p>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-5" data-testid="watch-series-grid">
            {series.map((s, i) => <SeriesCard key={s.id} series={s} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
